module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_5010.3276b4ac.png";